<!-- 合作客户 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_case.jpg"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <sub-title title="合作客户" en="COOPERATIVE CUSTOMER"></sub-title>
        <div class="content">
          <div class="desc">
            先后为成都市高新区财政金融局、高投集团、产城集团、高投建设、中交环投、中交水运规划设计院、成都高新未来科技城发展集团有限公司、成都城投集团信息科技有限公司、成都蒲江发展集团有限公司、成都蒲江建设投资集团有限公司、南充市高坪区审计局、南充市高坪区财政局、四川省高级人民法院、成都市中级人民法院、内江市中级人民法院、眉山市中级人民法院、四川省阆中市人民法院、四川省蓬安县人民法院、成都市新都区人民法院、中国人民解放军成都军事法院人民法院、四川省简阳市人民法院、成都仲裁委员会、都江堰市人民法院、四川省泸定县人民法院、中国航天建设集团有限公司、天府集团、通威股份、文锦置业、远鸿集团、东原集团、华宇集团、邦泰集团、领地集团、同诚众悦地产集团等客户提供了造价咨询系列服务。
          </div>
          <!-- <video
            class="video"
            src="../../assets/video.mp4"
            muted
            controls
            autoplay
          ></video> -->
          <div class="wait">视频待提供</div>
          <div class="desc">
            服务区域以成都为中心，辐射西南，面向全国，国外项目已服务至孟加拉、越南、缅甸等东南亚国家。
          </div>
          <img
            src="http://api.zyzxgc.cn/file/static/map.png"
            alt=""
            class="post"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      routerHistory: [], // 当前所在位置
      subNavs: [],
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find((ele) => {
        const firstPath = this.$route.path.split("/")[1];
        return ele.path != "/" && "/" + firstPath == ele.path;
      });
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 120px;

    .content {
      margin-top: 70px;
    }
    .desc {
      text-indent: 2em;
      font-size: 15px;
      color: #5e5d5d;
      line-height: 30px;
    }
    .video {
      width: 970px;
      height: 630px;
      display: block;
      margin: 50px auto;
      border-radius: 10px;
    }
    .wait {
      width: 970px;
      height: 630px;
      text-align: center;
      line-height: 630px;
      letter-spacing: 5px;
      background: #053a7a;
      color: #fff;
      border-radius: 10px;
      font-size: 49px;
      margin: 50px auto;
    }
    .post {
      width: 980px;
      display: block;
      margin: 50px auto 0;
    }
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;

      .content {
        margin-top: 20px;
      }
      .wait {
        width: 100%;
        height: 200px;
        line-height: 200px;
        font-size: 20px;
        margin: 20px 0;
      }
      .post {
        width: 100%;
        margin: 20px 0;
      }
    }
  }
}
</style>
